module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"action":"Voltar"},"en":{"action":"Go Back"},"es":{"action":"Vuelve"}}')
  delete Component.options._Ctor
}
